export default new class calculatorModalClass {
  constructor() {
    this.init();
  }

  init() {
    this.modal = document.querySelector('.kalkulyator__form-modal-overlay');

    this.openModal();
    this.closeModal();
    this.sendForm();
  }

  openModal() {
    const rentBtn = document.querySelector('.kalkulyator__form-send');

    rentBtn.addEventListener('click', () => {
      const orderData = {
        totalPrice: document.querySelector('._total-value').innerText,
        server: document.querySelector('._server-value').innerText,
        hdd: document.querySelector('._hdd-value').innerText,
        ram: document.querySelector('._ram-value').innerText,
        network: document.querySelector('._network-value').innerText,
        location: document.querySelector('._location-value').innerText,
      };

      window.currentOrder = orderData;

      this.modal.style.display = 'flex';
    });
  }

  closeModal() {
    $(document)
      .on('click', '.modal-close', () => {
        this.modal.style.display = 'none';
      });
  }

  // eslint-disable-next-line class-methods-use-this
  sendForm() {
    document.querySelector('#order-form').addEventListener('submit', function (e) {
      e.preventDefault();

      const loading = document.querySelector('._kalkulyator-modal-form-preloader');
      loading.style.display = 'block';

      const formData = new FormData(this);
      const fullData = {
        email: formData.get('email'),
        phone: formData.get('phone'),
        config: window.currentOrder,
      };

      $.request('Download::onSendCalculator', {
        data: {
          fullData,
        },
        complete: (res) => {
          if (res.responseJSON.status) {
            const success = document.querySelector('._kalkulyator-modal-form-success');
            loading.style.display = 'none';
            success.style.display = 'flex';
            setTimeout(() => {
              const modal = document.querySelector('.kalkulyator__form-modal-overlay');
              modal.style.display = 'none';
              success.style.display = 'none';
            }, 1500);
          }
        },
      });
    });
  }
}();
